import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Panel, Icon, Form, Col, Button, Message, Row, Checkbox } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ApproveProposalForm from '../../components/forms/approveProposalForm/ApproveProposalForm'
import { startLoading, doneLoading } from '../../utils/loading'
import { saveSecureApprove } from '../../redux/actions/approveProject'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  addToWaittingApproveList,
  addToWaittingNotApproveList,
} from '../../redux/actions/multiApprove'
import { Link } from 'react-router-dom'
import CoiApproveProjectWidget from '../coi/CoiApproveProjectWidget'
import COIValidateWidget from '../coi/COIValidateWidget'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import notification from '../../utils/notification'
import { SAVE_SUCCESS_MSG } from '../../constants/msgText'

export default function ApproveProposalWidget({
  schema,
  projectVersionId,
  onComplete,
  approverComment,
}) {
  const history = useHistory()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const [isShowConfimModalCoi, setIsShowConfimModalCoi] = useState(false)
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()

  const [formSchema, setFormSchema] = useState(schema)
  const [optionSelected, setOptionSelected] = useState(formSchema?.approveProposal?.value || 1)
  const [isAddList, setIsAddList] = useState(false)
  const [isCheckCOI, setIsCheckCOI] = useState(false)
  const [isCOIPass, setIsCOIPass] = useState(false)
  const [checkCOI, setCheckCOI] = useState(false)
  const [checkInterest, setCheckInterest] = useState(false)
  const [showCOIDetail, setShowCOIDetail] = useState(false)

  const handleSaveApproveProject = async (request) => {
    startLoading()
    setIsLoading(true)
    setErrorMessage(null)
    try {
      const _schema = await saveSecureApprove(request, projectVersionId || projectId)
      doneLoading()
      if (typeof onComplete === 'function') {
        setIsShowConfimModal(false)
        setIsShowConfimModalCoi(false)
        onComplete()
      } else {
        if (_schema.success) {
          if (request?.isCOI) {
            notification.open('success', {
              title: SAVE_SUCCESS_MSG,
              duration: 5000,
            })

            history.push({
              pathname: pathname.proposal.overview.overviewCoworker,
            })
          } else {
            window.location.href = _schema.secureApprovalUri
          }
        } else {
          setIsShowConfimModal(false)
          setIsShowConfimModalCoi(false)
          setErrorMessage(_schema.error)
        }

        // const _projectVersionId =
        //   _schema.projectVersionId ||
        //   _schema.model?.projectVersionId ||
        //   projectVersionId ||
        //   projectId
        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${_projectVersionId}`)
      }
    } catch (e) {
      console.log('error => ', e)
      if (e?.response?.data) {
        setErrorMessage(e.response.data.errorMessage || e.response.data.errors?.message)
      } else {
        setErrorMessage('เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    setIsShowConfimModal(false)
    setIsShowConfimModalCoi(false)
    setIsLoading(false)
    doneLoading()
  }

  const handleAddList = async (request) => {
    startLoading()
    setErrorMessage(null)
    try {
      if (optionSelected == 1) {
        await addToWaittingApproveList(request, 1)
      } else {
        await addToWaittingNotApproveList(request, 1)
      }

      setIsShowConfimModal(false)
      doneLoading()

      sessionStorage.setItem('projectId', projectVersionId || projectId)
      sessionStorage.setItem('param', '')

      return history.push(
        // `${pathname.proposal.overview.overviewCoworker}/${projectVersionId || projectId}`
        `${pathname.proposal.overview.overviewCoworker}`
      )
    } catch (e) {
      setErrorMessage(e?.errors?.message[0] || 'เกิดข้อผิดพลาดเพิ่มไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
    }
    setIsShowConfimModal(false)
    doneLoading()
  }

  const onSubmit = () => {
    setIsShowConfimModal(true)
  }

  const onSubmitAddList = () => {
    setIsAddList(true)
    onSubmit()
  }

  const handleOnConfirmModal = (data) => {
    if (isAddList) {
      const request = {
        projectVersionId: [projectVersionId || projectId],
      }
      handleAddList(request)
    } else {
      const requestData = {
        value: data.remark,
        selected: data.approveProposal,
        projectVersionId: projectVersionId || projectId,
        isCOI: checkInterest,
        // userId: '1',
      }
      handleSaveApproveProject(requestData)
    }

    // setIsShowConfimModal(false)
  }

  const handleSubmitCoi = (data) => {
    const requestData = {
      value: data.remark,
      selected: data.approveProposal,
      projectVersionId: projectVersionId || projectId,
      isCOI: checkInterest,
    }
    handleSaveApproveProject(requestData)
  }

  return (
    <>
      <Form fluid>
        <Panel
          shaded
          header={formSchema.headerApproveProposal}
          bordered
          collapsible
          defaultExpanded
        >
          {approverComment?.length > 0 &&
            approverComment.map((item, index) => {
              return (
                index != 0 && (
                  <Message
                    key={index}
                    type={'info'}
                    description={`${item.label} : ${item.value}`}
                  />
                )
              )
            })}
          <br />
          <>
            {formSchema.alert && (
              <>
                <Message showIcon type="warning" description={formSchema.alert} />
                <br />
              </>
            )}
            <ApproveProposalForm
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              onSelect={(value) => {
                setOptionSelected(value)
              }}
            />
            <br />

            {/* {optionSelected == 1 && 
              <Checkbox onChange={(value, checked) => setCheckCOI(checked)} checked={checkCOI}>
              ยืนยันการไม่มีส่วนเกี่ยวข้องโดยตรงกับผู้เสนอโครงการ แล้วจึงจะสามารถกดปุ่มส่ง&nbsp;
              <Link
                onClick={() => setShowCOIDetail(true)}
              >
                <u>อ่านข้อกำหนด</u>
              </Link>
            </Checkbox>} */}

            {/*check coi ยืนยันไม่มีส่วนได้เสีย*/}
            {optionSelected == 1 && (
              // <CoiApproveProjectWidget
              //   check={checkCOI}
              //   onCheck={(check) => setCheckCOI(check)}
              //   disabled={formSchema.disabled || isLoading}
              // />
              <COIValidateWidget
                disabled={formSchema.disabled || isLoading}
                isCOIPass={isCOIPass}
                setIsCOIPass={setIsCOIPass}
                checkCOI={checkCOI}
                setCheckCOI={setCheckCOI}
                setIsCheckCOI={setIsCheckCOI}
                setCheckInterest={setCheckInterest}
                checkInterest={checkInterest}
                fixType={'8'}
              />
            )}

            {!!errorMessage && (
              <Row style={{ marginBottom: 10 }}>
                <Message
                  showIcon
                  type="error"
                  description={errorMessage}
                  // closable
                  // onClose={() => {
                  //   setErrorMessage(null)
                  // }}
                />
              </Row>
            )}

            {formSchema.assetWarningMessage && (
              <Message showIcon type="warning" description={formSchema.assetWarningMessage} />
            )}
            <Col style={{ marginBottom: 20, textAlign: 'right' }} xs={24} sm={24} md={24} lg={24}>
              {/* {console.log(formSchema.buttonMultipleApproveLabel)} */}
              {formSchema.buttonMultipleApproveLabel &&
                (optionSelected == 1 || optionSelected == 3) && (
                  <Button
                    style={{ width: 160, marginRight: 10 }}
                    appearance="ghost"
                    color="orange"
                    onClick={handleSubmit(onSubmitAddList)}
                    icon={<Icon appearance="ghost" icon="edit" />}
                    disabled={formSchema.disabled || isLoading}
                  >
                    {optionSelected == 1 ? 'เพิ่มในรายการอนุมัติ' : 'เพิ่มในรายการไม่อนุมัติ'}
                  </Button>
                )}

              <Button
                style={{ width: 160 }}
                color="rgb(45, 168, 136)"
                appearance="primary"
                onClick={handleSubmit(onSubmit)}
                icon={<Icon appearance="ghost" icon="edit" />}
                // disabled={
                //   formSchema.disabled ||
                //   isLoading ||
                //   (optionSelected == 1 && (!checkCOI || !isCOIPass))
                // }
                disabled={
                  formSchema.disabled ||
                  isLoading ||
                  (optionSelected == 1 &&
                    ((!isCheckCOI && !checkInterest) || (!isCOIPass && !checkCOI)))
                }
              >
                {formSchema.buttonApproveProposalLabel}
              </Button>

              {checkInterest && (
                <SaveButton
                  children="บันทึก"
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    setIsShowConfimModalCoi(true)
                  }}
                />

                // <Button
                //   style={{ width: 160 }}
                //   color="rgb(45, 168, 136)"
                //   appearance="primary"
                //   onClick={handleSubmit(onSubmit)}
                //   icon={<Icon appearance="ghost" icon="edit" />}
                //   s
                // >
                //   บันทึก
                // </Button>
              )}
            </Col>
          </>
        </Panel>

        <ConfirmWidget
          title={`ยืนยัน${
            isAddList
              ? optionSelected == 1
                ? 'เพิ่มในรายการอนุมัติ'
                : 'เพิ่มในรายการไม่อนุมัติ'
              : formSchema.buttonApproveProposalLabel
          }`}
          show={isShowConfimModal}
          detail={`กรุณายืนยัน${
            isAddList
              ? optionSelected == 1
                ? 'เพิ่มในรายการอนุมัติ'
                : 'เพิ่มในรายการไม่อนุมัติ'
              : formSchema.buttonApproveProposalLabel
          }`}
          onCancle={() => setIsShowConfimModal(false)}
          onConfirm={handleSubmit(handleOnConfirmModal)}
        />

        <ConfirmWidget
          title={`ยืนยัน`}
          show={isShowConfimModalCoi}
          detail={`การมีส่วนได้เสีย`}
          onCancle={() => setIsShowConfimModalCoi(false)}
          onConfirm={handleSubmit(handleSubmitCoi)}
        />
      </Form>
    </>
  )
}
